export default __webpack_public_path__ + "static/media/01-icon-vertragsproduzenten.784f4c8d.svg";